<template>
  <div class="a2p-main">
    <div class="a2p-eyebrow">{{ eyebrow }}</div>
    <h1 class="a2p-title">Website compliance</h1>
    <p class="a2p-sub">
      Two copy-paste blocks to add to your privacy policy and terms of service pages
      before we submit. The carriers scan these pages — if the required language
      isn't there, registration gets rejected.
    </p>

    <A2PCallout type="info">
      We've already substituted your <strong>office phone</strong>, <strong>office email</strong>, and
      <strong>message frequency</strong> into the text below. Copy each block and paste it into the matching
      page on your website — then continue.
    </A2PCallout>

    <A2PCopyBlock
      title="Privacy Policy — add this section"
      sub="Paste into your privacy policy page"
      :body="PRIVACY_BLOCK"
      :office-phone="officePhone"
      :office-email="officeEmail"
      :message-frequency="messageFrequency"
    />

    <A2PCopyBlock
      title="Terms of Service — add this section"
      sub="Paste into your terms of service page"
      :body="TERMS_BLOCK"
      :office-phone="officePhone"
      :office-email="officeEmail"
      :message-frequency="messageFrequency"
    />

    <A2PCallout type="warn" v-if="!officePhone || !officeEmail">
      <strong>Missing office contact.</strong> Go back to Business Info and fill in the
      Office Phone and Office Email so these blocks substitute correctly.
    </A2PCallout>

    <div class="a2p-section" style="margin-top:32px">
      <div class="a2p-section-head">
        <div class="a2p-section-eyebrow">Checklist</div>
        <h2>What the carriers scan for</h2>
        <p class="a2p-section-desc">
          Each item below must appear somewhere on your privacy policy and/or terms page.
          Our copy-paste blocks include all of them — as long as you paste the text
          unchanged.
        </p>
      </div>
      <div class="a2p-checklist">
        <div v-for="item in COMPLIANCE_CHECKLIST" :key="item.id" class="a2p-check-item">
          <span class="check-icon">✓</span>
          <span class="check-label">{{ item.label }}</span>
          <span class="check-where">
            <span v-if="item.privacy">Privacy</span><span v-if="item.privacy && item.terms"> · </span><span v-if="item.terms">Terms</span>
          </span>
        </div>
      </div>
    </div>

    <div class="a2p-actions">
      <button type="button" class="a2p-btn a2p-btn-secondary" @click="$emit('back')">
        Back
      </button>
      <button
        type="button"
        class="a2p-btn a2p-btn-primary"
        @click="$emit('next')"
      >
        I've pasted both blocks — continue
      </button>
    </div>
  </div>
</template>

<script>
import A2PCallout from './components/A2PCallout.vue';
import A2PCopyBlock from './components/A2PCopyBlock.vue';
import { PRIVACY_BLOCK, TERMS_BLOCK, COMPLIANCE_CHECKLIST } from '@/utils/a2pValidation';

export default {
  name: 'A2PWizardWebsiteCompliance',
  components: { A2PCallout, A2PCopyBlock },
  props: {
    eyebrow: { type: String, default: '' },
    officePhone: { type: String, default: '' },
    officeEmail: { type: String, default: '' },
    messageFrequency: { type: String, default: 'Up to 8 msgs/month' },
  },
  data() {
    return { PRIVACY_BLOCK, TERMS_BLOCK, COMPLIANCE_CHECKLIST };
  },
};
</script>

<style src="./a2p-wizard.css"></style>
